import { LEADS_FILTERS } from "features/leads/constants";
import type { LeadsSearchParams } from "features/leads/types";

import { Accordion } from "common/components/ui/Accordion";
import { typedObjectEntries } from "common/helpers/utils";
import type { SelectedFacetParam } from "common/types";

import BooleanFilter from "../../Filters/BooleanFilter";
import Filter from "./Filter";

export interface FiltersProps {
  searchParams: LeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: Partial<LeadsSearchParams<SelectedFacetParam>>,
  ) => void;
}

export default function FiltersSelection({
  searchParams,
  setSearchParams,
}: FiltersProps) {
  return (
    <Accordion
      collapsible
      type="single"
      className="flex flex-col overflow-hidden"
    >
      {typedObjectEntries(LEADS_FILTERS).map(([searchKey, { label }]) =>
        // "favorite" is the only filter that holds a boolean
        searchKey === "favorite" ? (
          <BooleanFilter
            key={searchKey}
            label={label}
            isChecked={searchParams.favorite}
            onCheckedChange={(favorite) => setSearchParams({ favorite })}
          />
        ) : (
          <Filter
            key={searchKey}
            searchKey={searchKey}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        ),
      )}
    </Accordion>
  );
}
